import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _5616f8b8 = () => interopDefault(import('../../../pages/ateliers/index.vue' /* webpackChunkName: "pages/ateliers/index" */))
const _237759cb = () => interopDefault(import('../../../pages/stages-audepom.vue' /* webpackChunkName: "pages/stages-audepom" */))
const _1053a140 = () => interopDefault(import('../../../pages/ateliers/episode-special-juillet-2020.vue' /* webpackChunkName: "pages/ateliers/episode-special-juillet-2020" */))
const _3bd802df = () => interopDefault(import('../../../pages/ateliers/pares-au-decollage-mars-2023.vue' /* webpackChunkName: "pages/ateliers/pares-au-decollage-mars-2023" */))
const _0e565857 = () => interopDefault(import('../../../pages/ateliers/percez-mystere-machine-avril-2022.vue' /* webpackChunkName: "pages/ateliers/percez-mystere-machine-avril-2022" */))
const _00ad404f = () => interopDefault(import('../../../pages/ateliers/relancer-locomotive-novembre-2021.vue' /* webpackChunkName: "pages/ateliers/relancer-locomotive-novembre-2021" */))
const _450bd4d1 = () => interopDefault(import('../../../pages/courrier-vapeur/confirmation.vue' /* webpackChunkName: "pages/courrier-vapeur/confirmation" */))
const _a6681e8e = () => interopDefault(import('../../../pages/cours/team-city-battle.vue' /* webpackChunkName: "pages/cours/team-city-battle" */))
const _7c76c762 = () => interopDefault(import('../../../pages/evenements/atelier-fevrier-2025.vue' /* webpackChunkName: "pages/evenements/atelier-fevrier-2025" */))
const _08e85775 = () => interopDefault(import('../../../pages/evenements/atelier-mai-2025.vue' /* webpackChunkName: "pages/evenements/atelier-mai-2025" */))
const _5ee2a603 = () => interopDefault(import('../../../pages/evenements/atelier-octobre-2024.vue' /* webpackChunkName: "pages/evenements/atelier-octobre-2024" */))
const _e3114590 = () => interopDefault(import('../../../pages/evenements/fusion-extravaganza-mars-2023.vue' /* webpackChunkName: "pages/evenements/fusion-extravaganza-mars-2023" */))
const _632381cb = () => interopDefault(import('../../../pages/evenements/fusion-straciatella-2025.vue' /* webpackChunkName: "pages/evenements/fusion-straciatella-2025" */))
const _3d6965c3 = () => interopDefault(import('../../../pages/evenements/grand-bal-janvier-2025.vue' /* webpackChunkName: "pages/evenements/grand-bal-janvier-2025" */))
const _f7de498c = () => interopDefault(import('../../../pages/evenements/petit-et-grand-bal-mai-2025.vue' /* webpackChunkName: "pages/evenements/petit-et-grand-bal-mai-2025" */))
const _0547af50 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/ateliers",
    component: _5616f8b8,
    name: "ateliers"
  }, {
    path: "/stages-audepom",
    component: _237759cb,
    name: "stages-audepom"
  }, {
    path: "/ateliers/episode-special-juillet-2020",
    component: _1053a140,
    name: "ateliers-episode-special-juillet-2020"
  }, {
    path: "/ateliers/pares-au-decollage-mars-2023",
    component: _3bd802df,
    name: "ateliers-pares-au-decollage-mars-2023"
  }, {
    path: "/ateliers/percez-mystere-machine-avril-2022",
    component: _0e565857,
    name: "ateliers-percez-mystere-machine-avril-2022"
  }, {
    path: "/ateliers/relancer-locomotive-novembre-2021",
    component: _00ad404f,
    name: "ateliers-relancer-locomotive-novembre-2021"
  }, {
    path: "/courrier-vapeur/confirmation",
    component: _450bd4d1,
    name: "courrier-vapeur-confirmation"
  }, {
    path: "/cours/team-city-battle",
    component: _a6681e8e,
    name: "cours-team-city-battle"
  }, {
    path: "/evenements/atelier-fevrier-2025",
    component: _7c76c762,
    name: "evenements-atelier-fevrier-2025"
  }, {
    path: "/evenements/atelier-mai-2025",
    component: _08e85775,
    name: "evenements-atelier-mai-2025"
  }, {
    path: "/evenements/atelier-octobre-2024",
    component: _5ee2a603,
    name: "evenements-atelier-octobre-2024"
  }, {
    path: "/evenements/fusion-extravaganza-mars-2023",
    component: _e3114590,
    name: "evenements-fusion-extravaganza-mars-2023"
  }, {
    path: "/evenements/fusion-straciatella-2025",
    component: _632381cb,
    name: "evenements-fusion-straciatella-2025"
  }, {
    path: "/evenements/grand-bal-janvier-2025",
    component: _3d6965c3,
    name: "evenements-grand-bal-janvier-2025"
  }, {
    path: "/evenements/petit-et-grand-bal-mai-2025",
    component: _f7de498c,
    name: "evenements-petit-et-grand-bal-mai-2025"
  }, {
    path: "/",
    component: _0547af50,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
